import { RootState } from "../../../system/redux/store/community-finder-redux-store";

export const selectMapSettings = (state: RootState) => state?.mapSettings;
